import DialogButton from './DialogButton';
import { type ButtonProps } from '@mui/material';

const DialogSaveButton = ({ children, ...props }: ButtonProps) => (
  <DialogButton color="primary" {...props}>
    {children ?? 'Save'}
  </DialogButton>
);

export default DialogSaveButton;
